import { GrowthBook } from "@growthbook/growthbook-react";
const REACT_APP_GROWTHBOOK_API_HOST = process.env.REACT_APP_GROWTHBOOK_API_HOST;
const REACT_APP_GROWTHBOOK_CLIENT_KEY =
	process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY;

const gb = new GrowthBook({
	apiHost: REACT_APP_GROWTHBOOK_API_HOST,
	clientKey: REACT_APP_GROWTHBOOK_CLIENT_KEY,
	enableDevMode: true,
});

export { GrowthBook, gb };
